// Import model
import { ReferenceValue } from '../models/ReferenceValue';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for ReferenceValue - handles JSON serialization and deserialization with type validation
 */
export class ReferenceValueSerializer {
  /**
   * Deserializes a JSON string into a ReferenceValue instance
   */
  static deserialize(json: string): ReferenceValue {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a ReferenceValue instance
   */
  static fromObject(obj: any): ReferenceValue {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to ReferenceValue');
    }


    const instance: ReferenceValue = {
      description: obj['Description'] as string | undefined,
      id: obj['Id'] as string,
      imageUrl: obj['ImageUrl'] as string | undefined,
      value: obj['Value'] as string,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of ReferenceValue instances
   */
  static deserializeArray(json: string): ReferenceValue[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a ReferenceValue instance to a JSON string
   */
  static serialize(instance: ReferenceValue): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a ReferenceValue instance to a plain object
   */
  static toObject(instance: ReferenceValue): any {
    return {
      'Description': instance.description,
      'Id': instance.id,
      'ImageUrl': instance.imageUrl,
      'Value': instance.value,
    };
  }

  /**
   * Serializes an array of ReferenceValue instances to a JSON string
   */
  static serializeArray(instances: ReferenceValue[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
